import Alpine from 'alpinejs';
import formOtp from './components/admin/form-otp.js';
import toast from './components/admin/toast.js';

Alpine.data('formOtp', formOtp);
Alpine.data('toast', toast);

window.Alpine = Alpine;

Alpine.start();
